<button
  v-if="showTrigger && can_create_portal"
  class=" portal-sidebar-avatar border-0"
  data-bs-toggle="modal"
  data-bs-target="#portal_modal"
  data-bs-dismiss="offcanvas"
>
             <i class="bi bi-plus-lg"></i>

</button>
<teleport to="body">
<div class="modal fade" id="portal_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="exampleModalLabel">
            <span v-if="school_domain">Add a Grade</span>
            <span v-else>Create a Portal</span>
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="createPortal">
          <div class="modal-body modal-body-scroll">
  
            <!-- Portal Name Field -->
           <div class="mb-3">
              <label for="portal_name" class="form-label text-xxs fw-500">
                <span v-if="school_domain">Grade Name</span>
                <span v-else>Portal Name</span>
                <span class="text-danger">*</span>
              </label>
              
              <input 
                type="text" 
                class="form-control rounded text-xxs" 
                id="portal_name" 
                :placeholder="school_domain ? 'Enter grade name (Grade 1 )' : 'Enter portal name'"
                v-model="portal_name"
              >
              
              <p v-if="errors.portal_name" class="text-danger text-xxs">{{ errors.portal_name }}</p>
            </div>
  
            <!-- Contact Email (Only if "incident" is selected) -->
            <div v-if="selected_portal_type && (selected_portal_type.name === 'incident') ">
              <div class="mb-3">
                <label for="contact_email" class="form-label text-xxs fw-500">Authority Email</label>
                <input type="email" id="contact_email" class="form-control rounded text-xxs" v-model="contactEmail">
                <p v-if="errors.contact_email" class="text-danger text-xxs">{{ errors.contact_email }}</p>
              </div>
            </div>
  
            <!-- Show Master/Is Master only if type is "Engagement" -->
            <div class="d-none" v-if="selected_portal_type && (selected_portal_type.name === 'engagement' || selected_portal_type.name === 'publishing')">
              <!-- Is Master Checkbox -->
              <div class="mb-3">
                <label class="form-label text-xxs fw-500">Is Master Portal?</label>
                <div class="d-flex gap-3">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="is_master_yes" :value="true" v-model="isMaster">
                    <label class="form-check-label text-xxs" for="is_master_yes">Yes</label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" id="is_master_no" :value="false" v-model="isMaster">
                    <label class="form-check-label text-xxs" for="is_master_no">No</label>
                  </div>
                </div>
              </div>
  
              <!-- Select Sub-Portals if Master -->
              <div class="mb-3" v-if="isMaster">
                <a href="#" 
                class="text-primary text-xxs fw-500" 
                data-bs-toggle="modal" 
                data-bs-target="#select_portals_modal">
               + Add Sub-Portals
             </a>
             <div class="text-xxs">
              Selected sub-portals ({{ selectedPortals.length || 0 }})
            </div>
              </div>
  
              <!-- Select Master Portal if Not Master -->
              <div class="mb-3" v-if="!isMaster">
                <label class="form-label text-xxs fw-500">Select Master Portal</label>
                <select class="form-control rounded text-xxs" v-model="selectedMasterPortal">
                  <option value="" disabled selected>Select master portal</option>
                  <option v-for="portal in portals" :key="portal.id" :value="portal.id">
                    {{ portal.name }}
                  </option>
                </select>
                <p v-if="errors.master_portal" class="text-danger text-xxs">{{ errors.master_portal }}</p>
              </div>
              <!-- Public/Private Radio Buttons -->
  
         
  
  
            </div>
               <div class="d-flex gap-3 mt-2">
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="public" value="public"
                  v-model="selected_visibility">
                <label class="form-check-label text-xxs fw-500" for="public">
                  Public <br>
                  <span class="text-xxs text-secondary">
                    <span v-if="school_domain">Is the grade public?</span>
                    <span v-else>Is the portal public?</span></span>
                </label>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="flexRadioDefault" id="private" value="private"
                  v-model="selected_visibility">
                <label class="form-check-label text-xxs fw-500" for="private">
                  Private <br>
                  <span class="text-xxs text-secondary">
                    <span v-if="school_domain">Is the grade private?</span>
                    <span v-else>Is the portal private?</span>
                    </span>
                  
                </label>
              </div>
            </div>
            <div v-if="selected_visibility === 'private'" class="mb-3 border rounded bg-light p-3">
              <div class="d-flex justify-content-between align-items-start gap-3">
                <div>
                  <label class="text-xxs fw-bold text-dark d-block mb-0" for="component_portal_is_visible">
                    Invite Only Portal
                  </label>
                  <div class="text-xxs text-muted">
                    Turn this off if you want other users to see and request access to this private portal.
                  </div>
                </div>
                <div class="form-check form-switch mt-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="component_portal_is_visible"
                    :checked="!is_visible"
                    @change="is_visible = !$event.target.checked"
                  >
                </div>
              </div>
            </div>
            <!-- Mentoring Type Options -->
            <div v-if="selected_portal_type && selected_portal_type.name.toLowerCase() === 'mentoring'">
              <label class="form-label text-xxs fw-500">Mentoring Type</label>
              <div class="d-flex gap-3">
                <div
                  v-for="type in mentorship_types"
                  :key="type.id"
                  class="form-check"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    :id="'mentoring_type_' + type.id"
                    :value="type.id"
                    v-model="mentoring_type"
                    @change="mentoring_type_name = type.name.toLowerCase()"
                  />
                  <label class="form-check-label text-xxs" :for="'mentoring_type_' + type.id">
                    {{ type.name }}
                  </label>
                </div>
              </div>
              <p v-if="errors.mentoring_type" class="text-danger text-xxs">{{ errors.mentoring_type }}</p>

                <!-- Public/Private Radio Buttons -->
                <div v-if="mentoring_type" class="d-flex gap-3 mt-2">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="public" value="public"
                      v-model="selected_visibility">
                    <label class="form-check-label text-xxs fw-500" for="public">
                      Public <br>
                      <span class="text-xxs text-secondary">Is the portal public?</span>
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="private" value="private"
                      v-model="selected_visibility">
                    <label class="form-check-label text-xxs fw-500" for="private">
                      Private <br>
                      <span class="text-xxs text-secondary">Is the portal private?</span>
                    </label>
                  </div>
                </div>

                  <!-- Show Skills for Mentor or Both -->
                  <div v-if="selected_visibility && (mentoring_type_name === 'mentor' || mentoring_type_name === 'both')" class="mt-3">
                    <label class="form-label text-xxs fw-500">Skills</label>
                    <a href="#" class="text-primary text-xxs fw-500" @click.prevent="show_skill_input = true">+ Add Skills</a>
                    <div class="text-xxs mt-2">
                      <span
                        v-for="(skill, index) in skills"
                        :key="index"
                        class="position-relative d-inline-block me-2"
                      >
                        <span class="badge bg-secondary px-3 py-2">
                          {{ skill }}
                        </span>
                        <i
                          class="bx bx-x text-dark fs-6 position-absolute top-0 start-100 translate-middle cursor-pointer"
                          @click="remove_skill(index)"
                        ></i>
                      </span>
                    </div>

                    <div v-if="show_skill_input" class="d-flex align-items-center mt-2">
                      <input type="text" class="form-control rounded text-xxs me-2 mb-2" v-model="new_skill" placeholder="Enter skill">
                      <button class="btn btn-sm btn-primary text-xxs rounded-3 shadow-sm" @click.prevent="add_skill">add</button>
                    </div>
                  </div>

                  <!-- Show Learning Skills for Mentee or Both -->
                  <div v-if="selected_visibility && (mentoring_type_name === 'mentee' || mentoring_type_name === 'both')" class="mt-3">
                    <label class="form-label text-xxs fw-500">Learning Skills</label>
                    <div>
                      <a href="#" class="text-primary text-xxs fw-500" @click.prevent="show_learning_skill_input = true">+ Add Learning Skills</a>
                    </div>
                    <div class="text-xxs mt-2">
                      <span
                        v-for="(skill, index) in learning_skills"
                        :key="index"
                        class="position-relative d-inline-block me-2"
                      >
                        <span class="badge bg-info px-3 py-2">
                          {{ skill }}
                        </span>
                        <i
                          class="bx bx-x text-dark fs-6 position-absolute top-0 start-100 translate-middle cursor-pointer"
                          @click="remove_learning_skill(index)"
                        ></i>
                      </span>
                    </div>

                    <div v-if="show_learning_skill_input" class="d-flex align-items-center mt-2">
                      <input type="text" class="form-control rounded text-xxs me-2 mb-2" v-model="new_learning_skill" placeholder="Enter learning skill">
                      <button class="btn btn-sm btn-info text-xxs rounded shadow-sm" @click.prevent="add_learning_skill">add</button>
                    </div>
                  </div>


                <!-- Description Field -->
                <div class="mb-3">
                  <label for="description" class="form-label text-xxs fw-500">Description</label>
                  <textarea class="form-control rounded text-xxs" id="description" v-model="description"></textarea>
                  <p v-if="errors.description" class="text-danger text-xxs">{{ errors.description }}</p>
                </div>
              </div>
  
  
            <!-- User Selection Field -->
            <div v-if="selected_visibility === 'private'" class=" mt-2">
              <label class="form-label text-xxs fw-500">
                <span v-if="school_domain">{{ add_members_label }}</span>
                <span v-else>{{ is_invite_only_portal ? 'Invite Portal Members' : 'Add Portal Members' }}</span>
              </label>
            <div class="d-flex justify-content-between align-items-center p-2 border rounded bg-light">
              <div>
                <h6 class="text-xxs fw-bold text-uppercase mb-1 text-muted">
                  Tagged {{ school_domain ? 'Members' : 'Portal Members' }}
                </h6>
                <div class="text-xxs fw-600">
                  <i class="fas fa-users me-1"></i> 
                  {{ selectedUserIds.length || 0 }} total
                </div>
              </div>

              <button 
                type="button" 
                class="btn btn-sm btn-primary py-1 px-2 text-xxs fw-600"
                data-bs-toggle="modal" 
                data-bs-target="#portal_member_modal"
              >
                <i class="fas fa-plus me-1"></i>
                {{ school_domain ? add_members_label : (is_invite_only_portal ? 'Invite Portal members' : 'Add Portal members') }}
              </button>
            </div>

            <p v-if="errors.user_ids" class="text-danger text-xxs mt-2 mb-0">
              <i class="fas fa-exclamation-circle me-1"></i> {{ errors.user_ids }}
            </p>
          </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
 

  <div class="modal fade" id="select_portals_modal" tabindex="-1" aria-labelledby="selectPortalsLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <p class="modal-title text-xxs fw-500" id="selectPortalsLabel">Select Sub-Portals</p>
          <button type="button" class="btn-close text-xxs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
  
        <form @submit.prevent="confirmSelectedPortals">
          <div class="modal-body">
            <!-- Search Input -->
            <div class="mb-3">
              <input
                type="text"
                v-model="searchQuery"
                class="form-control text-xxs"
                placeholder="Search portals by name..."
              />
            </div>
  
            <!-- Portals Table -->
            <table class="table table-striped text-xxs">
              <thead class="btn-primary text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Portal Name</th>
                  <th scope="col">
                    Action 
                    <span class="ms-2">
                      <input  
                        class="form-check-input" 
                        type="checkbox" 
                        id="select_all_checkbox" 
                        :checked="areAllSubPortalsSelected" 
                        @change="toggleSelectAllSubPortals"
                      />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(portal, index) in filteredPortals" :key="portal.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ portal.name }}</td>
                  <td>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        :id="'portal_check_' + portal.id" 
                        :value="portal.id" 
                        v-model="selectedPortals"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
  
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Add Portals</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="portal_member_modal" tabindex="-1" aria-labelledby="portalMemberLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="portalMemberLabel">{{ is_invite_only_portal ? 'Invite Portal Members' : 'Add Portal Members' }}</p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="addPortalMembers">
          <div class="modal-body table-responsive">
            <div class="mb-3">
              <input
                type="text"
                v-model="searchQuery"
                class="form-control text-xxs"
                placeholder="Search members by name..."
              />
            </div>
            <table class="table table-striped text-xxs">
              <thead class="btn-primary text-white">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">Action<span class="ms-2"><input  class="form-check-input" type="checkbox" id="select_all_checkbox" :checked="areAllSelected" @change="toggleSelectAll"/></span></th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(user, index) in filteredUsers" :key="user.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ user.first_name }}</td>
                  <td>{{ user.last_name }}</td>
                  <td>{{ user.email }}</td>
                  <td>
                    <div class="form-check d-flex justify-content-center">
                      <input 
                        class="form-check-input" 
                        type="checkbox" 
                        :id="'portal_member_check_' + user.id" 
                        :value="user.id" 
                        v-model="selectedUserIds"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">{{ add_members_label }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>

   </teleport>
